import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/shared/Layout/Layout';
import Button from '../../components/shared/Button/Button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div
        style={{
          textAlign: 'center',
          padding: '80px 20px',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <h1
          style={{
            fontSize: '88px',
            background: 'var(--gradient-accent)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '12px',
          }}
        >
          404
        </h1>
        <h2 style={{ marginBottom: '12px' }}>Página no encontrada</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
          La página que buscas no existe o ha sido movida.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button onClick={() => navigate('/')}>Ir al inicio</Button>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Volver
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
